import React from 'react';

const bubbles = [
  { w: 130, h: 130, top: '18%', left: '12%', opacity: 0.10, border: true },
  { w: 70, h: 70, top: '55%', left: '6%', opacity: 0.09, border: true },
  { w: 100, h: 100, top: '30%', right: '14%', opacity: 0.11, border: true },
  { w: 45, h: 45, top: '22%', right: '35%', opacity: 0.08, border: true },
  { w: 55, h: 55, top: '48%', left: '30%', opacity: 0.07, fill: 'rgba(13,43,79,0.03)' },
];

const SectionBubbles = () => (
  <div className="section-bubbles" aria-hidden="true">
    {bubbles.map((b, i) => (
      <span
        key={i}
        style={{
          position: 'absolute',
          width: b.w,
          height: b.h,
          borderRadius: '50%',
          border: b.border ? `2px solid rgba(13,43,79,${b.opacity})` : 'none',
          background: b.fill || 'none',
          top: b.top, left: b.left, right: b.right, bottom: b.bottom,
          pointerEvents: 'none',
        }}
      />
    ))}
  </div>
);

export default SectionBubbles;
